import React from 'react';
import { SparklesIcon } from '@heroicons/react/24/outline';

const NosEngagementsPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="relative py-20 overflow-hidden">
        <img 
          src="/assets/images/bague-or-18-carats-diamants-aupiho-joaillerie.jpeg"
          alt="Bague en or 18 carats avec diamants - Aupiho Joaillerie"
          className="absolute inset-0 w-full h-full object-cover object-center"
          style={{ position: 'fixed' }}
          loading="lazy"
        />
        <div className="absolute inset-0 bg-black/70"></div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl md:text-6xl font-light text-white mb-6 tracking-wide" style={{ fontFamily: 'MoonTime, cursive' }}>
              Nos engagements
            </h1>
            <div className="flex items-center justify-center gap-3 mb-6">
              <div className="w-12 h-px bg-[#c69c70]"></div>
              <SparklesIcon className="h-8 w-8 text-[#c69c70]" />
              <div className="w-12 h-px bg-[#c69c70]"></div>
            </div>
            <p className="text-xl text-white/90 font-light max-w-2xl mx-auto">
              Notre engagement pour une joaillerie responsable et éthique
            </p>
          </div>
        </div>
      </section>

      {/* LE MADE IN FRANCE */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-16 max-w-6xl mx-auto items-center">
            <div className="order-2 md:order-1">
              <h2 className="text-4xl font-light text-[#c69c70] mb-6 tracking-wide">LE MADE IN FRANCE</h2>
              <div className="space-y-4 text-gray-700 leading-relaxed text-base">
                <p>
                  Chez AUPIHO nous avons fait le choix du <strong className="text-[#497aab]">100% fabriqué en France</strong>.
                </p>
                <p>
                  Aujourd'hui une partie importante de la fabrication joaillière est faite en Asie. Pourtant le savoir-faire français en joaillerie est réputé pour être un des meilleurs au monde !
                </p>
                <p>
                  Nos ateliers partenaires sont certifiés par de nombreux labels français et internationaux : « Entreprise du Patrimoine Vivant », « Joaillerie de France », « ISO 9001 », « Responsible Jewellery Council » et « Chain Of Custody »
                </p>
              </div>
            </div>
            
            <div className="order-1 md:order-2">
              <div className="relative overflow-hidden rounded-2xl shadow-xl">
                <img 
                  src="/assets/images/engagements/made-in-france.jpg" 
                  alt="Made in France - Artisan joaillier" 
                  className="w-full h-full object-cover aspect-[4/3]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#c69c70]/20 to-transparent"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* LE FABRIQUÉ MAIN */}
      <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-16 max-w-6xl mx-auto items-center">
            <div className="order-1 md:order-1">
              <div className="relative overflow-hidden rounded-2xl shadow-xl">
                <img 
                  src="/assets/images/engagements/fabrique-main.jpg" 
                  alt="Fabriqué main - Artisan joaillier" 
                  className="w-full h-full object-cover aspect-[4/3]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#c69c70]/20 to-transparent"></div>
              </div>
            </div>

            <div className="order-2 md:order-2">
              <h2 className="text-4xl font-light text-[#c69c70] mb-6 tracking-wide">LE FABRIQUÉ MAIN</h2>
              <div className="space-y-4 text-gray-700 leading-relaxed text-base">
                <p>
                  Tous nos bijoux sont <strong className="text-[#497aab]">fabriqués à la main</strong> dans nos ateliers partenaires. Chaque étape de la création du bijou est minutieusement suivie par nos équipes d'artisans joailliers, de la conception à la création finale du bijou.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* AUTHENTICITÉ */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-4xl font-light text-[#c69c70] mb-8 tracking-wide text-center">AUTHENTICITÉ</h2>
            <div className="space-y-4 text-gray-700 leading-relaxed text-base">
              <p>
                Toutes nos créations sont poinçonnées avec <strong className="text-[#497aab]">le poinçon tête d'aigle</strong> qui certifie que les bijoux sont en <strong className="text-[#497aab]">or 18 carats</strong> et fabriqués en France. Nous avons fait ce choix afin d'apporter une valeur additionnelle à la garantie de nos bijoux même si la loi n'oblige à avoir un poinçon tête d'aigle que pour les bijoux qui pèsent plus de 3g d'or.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* DIAMANTS ÉTHIQUES */}
      <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-16 max-w-6xl mx-auto items-center">
            <div className="order-2 md:order-1">
              <h2 className="text-4xl font-light text-[#c69c70] mb-6 tracking-wide">DIAMANTS ÉTHIQUES</h2>
              <div className="space-y-4 text-gray-700 leading-relaxed text-base">
                <p>
                  Les bijoux AUPIHO sont sertis de diamants blancs classification H-SI (sauf si précisé voir fiche produit).
                </p>
                <p>
                  Nous collaborons avec des diamantaires <strong className="text-[#497aab]">certifiés par le Responsible Jewelry Council (RJC)</strong> et qui respectent le <strong className="text-[#497aab]">processus de Kimberley</strong> garantissant une extraction « responsable » ainsi que la provenance de pays non liés à des conflits.
                </p>
              </div>
            </div>
            
            <div className="order-1 md:order-2">
              <div className="relative overflow-hidden rounded-2xl shadow-xl">
                <img 
                  src="/assets/images/engagements/diamants-ethiques.jpg" 
                  alt="Diamants éthiques" 
                  className="w-full h-full object-cover aspect-[4/3]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#c69c70]/20 to-transparent"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* NOS PACKAGING ÉCOCONCUS */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-16 max-w-6xl mx-auto items-center">
            <div className="order-1 md:order-1">
              <div className="relative overflow-hidden rounded-2xl shadow-xl">
                <img 
                  src="/assets/images/engagements/packaging-ecoconcus.jpg" 
                  alt="Packaging écoconçus FSC" 
                  className="w-full h-full object-cover aspect-[4/3]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#c69c70]/20 to-transparent"></div>
              </div>
            </div>

            <div className="order-2 md:order-2">
              <h2 className="text-4xl font-light text-[#c69c70] mb-6 tracking-wide">NOS PACKAGING ÉCOCONCUS</h2>
              <div className="space-y-4 text-gray-700 leading-relaxed text-base">
                <p>
                  Nous avons voulu être en phase avec nos idées de développement durable. Nos <strong className="text-[#497aab]">packagings sont en carton certifié FSC mixte</strong> (Forest Stewardship Council) est un label environnemental, dont le but est d'assurer que la production de bois ou d'un produit à base de bois respecte les procédures garantissant la gestion durable des forêts)
                </p>
                <p>
                  La taille de nos écrins est en harmonie avec la taille de nos bijoux.
                </p>
                <p>
                  Notre fournisseur de packaging est basé en Europe et l'encre utilisée pour notre logo est <strong className="text-[#497aab]">sans solvant</strong>.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default NosEngagementsPage;

